// import { Token } from '@angular/compiler';
import { Component,
         OnInit,
         AfterViewInit,
         OnDestroy, 
         HostListener} from '@angular/core';

import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';

// import { CookieService } from 'ngx-cookie';
import { filter, map, Subject, takeUntil } from 'rxjs';

import { AppStatic,
         TokenService,
         AuthService,
         SeoService } from './_core';

// import { environment } from './environments';
// environment


// import * as jwt from 'jsonwebtoken';

import { WindowService } from 'src/app/_core/index'


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  title = 'lcp'
  token$: any

  GoogleAuth: any

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    // private cookieService: CookieService,
    private authService: AuthService,
    // private route: ActivatedRoute,
    // private routerService: RouterService,
    private windowService: WindowService,
    private router: Router,
    private seoService: SeoService,
    // private tokenService: TokenService
  ) {}

  // // @HostListener('focusin')
  // @HostListener('document:mouseenter', ["$event"]) 
  // onDocumentMouseEnter(event: any) {
  // // document.on('mouseenter', onMouseEnter(evt: any) {
  // // document.addEventListener('mouseenter', (event) => {
  //   console.log('TODO: onMouseEnter', event)
  // }

  // // @HostListener('focusout')
  // // @HostListener('mouseleave', ["$event"])
  // // onMouseLeave(evt: any) {
  // @HostListener('document:mouseleave', ["$event"]) 
  // onDocumentMouseLeave(event: any) {
  //   console.log('TODO: onMouseLeave', event)
  //   // if (this.options['trigger'] === 'hover') this.destroyTooltip()
  // }


  ngOnInit() {
    // this.loadPaypal()

    // let options = {  }
    // let cook = this.getCookie('lcp_user')
    this.listenToStorage()

    this.authService.populateAuth()

    this.listenToTitle()
  }

  // adds paypal script to <head>
  // loadPaypal() {
  //   if (!environment.paypal_client_id) console.log('ERR: NO PAYPAL ID IN ENVIRONMENT...')

  //   let node = document.createElement('script'); // creates the script tag
  //   // <script src="https://www.paypal.com/sdk/js?currency=USD&disable-funding=credit&client-id=ATSK4W0ZTcygJjkoQqcSzfNEua6zS3itj8j49d34DruvJE3wexHmmHVmm0yeLNQqttmfgKd7_3bdkOxR"></script>   <!-- OAK_PARK LIVE -->

  //   let url = 'https://www.paypal.com/sdk/js?currency=USD&disable-funding=credit&client-id='; // sets the source (insert url in between quotes)
  //   url += environment.paypal_client_id
  //   node.src = url
  //   node.type = 'text/javascript'; // set the script type
  //   node.async = true; // makes script run asynchronously
  //   node.charset = 'utf-8';
  //   // append to head of document
  //   document.getElementsByTagName('head')[0].appendChild(node); 
  //   console.log('LOADED PAYPAL', node)
  // }

  ngAfterViewInit() {
    if (!AppStatic.isBrowser) return
    document.addEventListener('scroll', (e) => this.onScroll(e))
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  // getAccessToken(): void {
  //   this.authService.getAccessToken(GoogleLoginProvider.PROVIDER_ID).then(accessToken => this.accessToken = accessToken);
  // }

  listenToStorage() {
    if (!AppStatic.isBrowser) return
    // console.log('(listening to local storage)')
    window.addEventListener('storage', function(event){
      // console.log('storage evt:', event)
      if (event.storageArea === localStorage) {
        // It's local storage
        // console.log('localStorage', event)
      }
    }, false);
  }

  // getCookie(key: string){
  //   // console.log('getCookie', key, this.cookieService.get(key), this.cookieService.getObject(key))
  //   return this.cookieService.get(key)
  // }

  // getCookieObject(key: string){
  //   // console.log('cookie', key, this.cookieService.get(key), this.cookieService.getObject(key))
  //   return this.cookieService.getObject(key)
  // }

  // putCookieObject(key: string, obj: any, options?) {
  //   this.cookieService.putObject(key, obj, options)
  // }

  // https://dev.to/brandontroberts/setting-page-titles-natively-with-the-angular-router-393j
  // sets title / meta / canonical from the primary route's data (merged parent => child);
  // detail pages (work/:slug, ...) add their own title and description once content loads
  listenToTitle() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let data: any = {};
          while (route) {
            Object.assign(data, route.snapshot.data);
            route = route.children.find(child => child.outlet === PRIMARY_OUTLET);
          }
          return data;
        })
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.seoService.set({
          title: data['title'],
          description: data['description'],
          noindex: data['noindex'],
          breadcrumbs: data['breadcrumbs'],
          path: this.primaryPath(),
        });
      });
  }

  // '/work/sfo-branding(p:login)?x=1#top' => '/work/sfo-branding'
  primaryPath() {
    let primary = this.router.parseUrl(this.router.url).root.children[PRIMARY_OUTLET];
    return '/' + (primary ? primary.segments.map(segment => segment.path).join('/') : '');
  }

  onScroll(e: any) {
    // console.log('scrolling')
    this.windowService.updateScrollContainers()
  }
 
  initWindowScrollContainer() {
    this.windowService.updateScrollElement('window', window)
  }

}
